import { useState } from "react";
import styled from "styled-components";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useFormContext } from "react-hook-form";
import PolicySectionModal from "./modal";
import ValidationMessage from "../ValidationMessage";
import {
  partitionPolicyText,
  isGlobalPolicyMissing,
  POLICY_MISSING_MESSAGE
} from "../../services/helper";

// The whole text is the checkbox label: on phones it is the tap target,
// the 22px box alone was easy to miss
const ConfirmationLabel = styled.label`
  font-size: 12px;
  font-weight: 400;
  margin-left: 10px;
  color: #666666;
  line-height: 1.35;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
const KeywordText = styled.span`
  cursor: pointer;
`;

export const PolicySection = ({ policyScope }) => {
  const {
    register,
    formState: { errors }
  } = useFormContext();
  const policyVersion = useSelector(
    (state) => state.funnelInfo.funnel.policyVersion
  );
  const { amPrivacyPolicy } = useSelector(
    (state) => state.globalPrivacyPolicyInfo
  );
  const [showModal, setShowModal] = useState(false);
  const toggleShowModal = () => setShowModal((prev) => !prev);

  // No consent without its text: without the checkbox the required
  // policyCheck stays false, so the form cannot be submitted
  if (isGlobalPolicyMissing({ policyScope, amPrivacyPolicy })) {
    return (
      <div className="mt-4">
        <ValidationMessage message={POLICY_MISSING_MESSAGE} />
      </div>
    );
  }

  const { checkboxText, checkboxClickableKeyword, modalHeading, modalContent } =
    (policyScope === "GLOBAL" ? amPrivacyPolicy : policyVersion) || {};

  const policyTextParts = partitionPolicyText({
    checkboxText,
    checkboxClickableKeyword
  });

  return (
    <>
      <div className="mt-4 d-flex">
        <Form.Check
          id="policyCheck"
          className="fs-4"
          type="checkbox"
          {...register("policyCheck")}
        />
        <ConfirmationLabel htmlFor="policyCheck">
          <div>
            {policyTextParts.prefix}
            <KeywordText
              onClick={(event) => {
                // Opens the policy without ticking the checkbox
                event.preventDefault();
                toggleShowModal();
              }}
              className="text-primary cursor-pointer"
            >
              {policyTextParts.clickable}
            </KeywordText>
            {policyTextParts.suffix}
          </div>
        </ConfirmationLabel>
      </div>
      <div>
        {errors?.policyCheck && (
          <ValidationMessage message={errors.policyCheck.message} />
        )}
      </div>
      <PolicySectionModal
        modalHeading={modalHeading}
        modalContent={modalContent}
        show={showModal}
        onHide={toggleShowModal}
      />
    </>
  );
};
